/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const HubspotFragment = {
  Hubspot: gql`
    fragment HubspotQuery on hubspot_Entry {
      hubspotContent
      hubspotType
      typeHandle
    }
  `,
};
